import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://bbzeapqhbmyrggqphapv.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJiemVhcHFoYm15cmdncXBoYXB2Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcwOTY1NjQyNSwiZXhwIjoyMDI1MjMyNDI1fQ.ID0XolbCn2sdE4p8kwg_oGXxqStwOoQoYH_8QAaAf9w';

export const supabase = createClient(supabaseUrl, supabaseKey); 